import { useCallback } from 'react'

import {
  IconArrowInbox,
  Button,
  useNotifications,
  Center
} from '@sequencehq/core-components'

import { downloadBlob } from '@sequencehq/utils'

type Props = {
  url: string
  fileName: string
}

export const AttachmentBinaryPreview = ({ url, fileName }: Props) => {
  const { displayNotification } = useNotifications()

  const onClick = useCallback(async () => {
    try {
      const response = await fetch(url)

      if (!response.ok) {
        displayNotification('Unable to download file', { type: 'error' })
        return
      }

      const data = await response.blob()

      downloadBlob(fileName)(data)
    } catch (_) {
      displayNotification('Unable to download file', { type: 'error' })
    }
  }, [fileName, url, displayNotification])

  return (
    <Center width="100%" height="100%">
      <Button
        variant="secondary"
        leadingIcon={<IconArrowInbox />}
        onClick={onClick}
      >
        Download file
      </Button>
    </Center>
  )
}
